import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import img2 from '../images/ipo.svg';
import img3 from '../images/ADV.svg';
import img4 from '../images/ma.svg';
import img5 from '../images/PR.svg';

const Services = () => {
    const services = [
        { 
            img: img2, 
            title: "IPO Management", 
            content: "Comprehensive assistance in going public, from regulatory compliance to structuring, valuation, and managing the offering process.",
            link: "/sme"
        },
        { 
            img: img3, 
            title: "Financial Advisory", 
            content: "Expert guidance on capital raising, corporate structuring, risk management, and financial optimizations to build long-term value.",
            link: "/contact"
        },
        { 
            img: img4, 
            title: "Merger and Acquisition", 
            content: "Strategic M&A advisory, target identification, valuation, and transaction structuring to ensure alignment with corporate objectives.",
            link: "/contact"
        },
        { 
            img: img5, 
            title: "PR and Marketing", 
            content: "Tailored communication strategies to build investor interest, shape company narratives, and build trust ahead of listing.",
            link: "/contact"
        }
    ];

    return (
        <div id="services" className="bg-slate-50 py-12 md:py-16">
            <div className="container mx-auto px-6 max-w-7xl">
                
                {/* Header */}
                <div className="text-center mb-12" data-aos="fade-up">
                    <span className="text-sm font-semibold tracking-wider uppercase text-cyan-600 mb-2 block">
                        Our Expertise
                    </span>
                    <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4">
                        Customized Financial Services
                    </h2>
                    <div className="flex justify-center mb-4">
                        <div className="w-16 h-1 bg-cyan-500 rounded-full"></div>
                    </div>
                    <p className="text-slate-600 max-w-2xl mx-auto text-base">
                        We are deeply committed to the growth and success of our clients, offering a wide array of specialized corporate finance solutions.
                    </p>
                </div>

                {/* Services Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-aos="fade-up" data-aos-delay="200">
                    {services.map((service, index) => (
                        <div 
                            key={index} 
                            className="bg-white rounded-3xl border border-slate-100 shadow-sm hover:shadow-xl hover:-translate-y-1.5 transition-all duration-300 flex flex-col overflow-hidden group w-full"
                        >
                            {/* Graphic Container */}
                            <div className="h-48 overflow-hidden bg-slate-50 relative">
                                <div className="absolute inset-0 bg-cyan-900/5 group-hover:bg-cyan-900/0 transition-colors duration-300 z-10"></div>
                                <img 
                                    alt={service.title} 
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-in-out" 
                                    src={service.img} 
                                    key={index} 
                                />
                            </div>
                            
                            {/* Content */}
                            <div className="p-6 flex-grow flex flex-col justify-between">
                                <div>
                                    <h3 className="text-xl font-bold text-slate-800 mb-3 group-hover:text-cyan-600 transition-colors duration-200">
                                        {service.title}
                                    </h3>
                                    <p className="text-slate-500 text-sm leading-relaxed mb-6">
                                        {service.content}
                                    </p>
                                </div>
                                
                                <Link 
                                    to={service.link} 
                                    className="inline-flex items-center text-sm font-semibold text-cyan-600 hover:text-cyan-700 transition-colors gap-1.5 group/btn mt-auto"
                                >
                                    Learn More 
                                    <ArrowRight size={16} className="transform group-hover/btn:translate-x-1 transition-transform duration-200" />
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default Services;